import { ActualRevenueStats } from '../../../../api/Providers/Stats';
import { RevenueStats, WithDate } from '../types';

export const deriveGrossRevenue = (
  revenue: WithDate<ActualRevenueStats>[],
): WithDate<RevenueStats>[] => revenue.map(actualRevenue => ({
  ...actualRevenue,
  gross_revenue: actualRevenue.processed_revenue + actualRevenue.nonprocessed_revenue,
}));
